import { render } from "./asideLink.vue?vue&type=template&id=6a25ce05"
import script from "./asideLink.vue?vue&type=script&lang=js"
export * from "./asideLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__